import React, { useEffect, useState } from "react";
import ResourcesTab from "./ResourcesTab";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import LogoContainer from "../common/LogoContainer";
import MobileImage from "../../Assets/images/TrustPlus_MobileImg.png";
import { DialogComponent } from "../common/DialogComponent";
import RedirectTrustPlusDialog from "../Dialogs/RedirectTrustPlusDialog";

const FinancialCoaching = () => {
    const dispatch = useDispatch();
    const loginUserName: any = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo && state.loggedInUser.userInfo.loginUserName ? state.loggedInUser.userInfo.loginUserName : null
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [isDialogOpen, setDialogOpen] = useState(false);

    const openDialog = () => {
        setDialogOpen(true);
    };
    const closeDialog = () => {
        setDialogOpen(false);
    };
    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    useEffect(() => {
        window.addToDataLayer({ event: "FinancialCoaching" });
    }, []);

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="financial-coaching-page" tabIndex={-1}>
                        Resources
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>
            <ResourcesTab selectedTab="10" />

            <div className="row" id="content">
                <div className="financial-coaching col-xs">
                    <div className="box offset-padding">
                        <div className="row">
                            <div className="col-xs-12 col-sm-8">
                                <div className="row">
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon" aria-hidden="true">
                                                <em className="las la-coins"></em>
                                            </div>
                                            <div className="box-title-text">
                                                <h2 className="box-title">You're already protecting your identity&mdash; now protect your financial wellness</h2>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="box-description">
                                        <p>
                                            With TrustPlus, you can get unlimited access to financial coaches who can help you reach your goals and protect your
                                            financial future at no additional cost. Create a TrustPlus account to access one-on-one coaching on topics such as:
                                        </p>
                                    </div>

                                    <div className="box-actions"></div>

                                    <div className="box-content">
                                        <div className="col-xs-12 col-sm-12">
                                            <ul className="list-style-disc">
                                                <p className="margin-top margin-bottom">
                                                    <li>Reducing debt</li>
                                                    <li>Budgeting</li>
                                                    <li>Building savings</li>
                                                    <li>Using credit wisely</li>
                                                </p>
                                            </ul>
                                            <button
                                                className="btn-default btn-primary"
                                                onClick={(e) => {
                                                    openDialog();
                                                    window.addToDataLayer({ event: "Go To TrustPlus Now Event" });
                                                }}
                                            >
                                                <span className="btn-text">Go To TrustPlus Now</span>
                                            </button>

                                            <p className="financial-coaching-footer margin-top">
                                                You will need to create a separate account with TrustPlus to access their services. If you want to close your
                                                account, you will need to do so directly with TrustPlus. These services are provided by an unaffiliated third party.
                                                IdentityForce, a TransUnion brand, and Sontiq Inc., do not warranty the services provided or guarantee results.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-4 image-center">
                                <img src={MobileImage} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isDialogOpen && (
                <DialogComponent hideCloseButton={false} dialogId="dialog-redirect-trustplus" title="Redirect TrustPlus Site" closeDialog={closeDialog}>
                    <RedirectTrustPlusDialog closeDialog={closeDialog} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default FinancialCoaching;
